<!-- youtube-desktop-01 preview — YouTube watch ad (skippable in-stream) -->
<app-desktop-frame>
  <!-- START: Watch page -->
  <div class="yt-wd-page d-flex flex-column">
    <div class="yt-wd-header">
      <app-youtube-navbar></app-youtube-navbar>
    </div>

    <div class="yt-wd-body d-flex flex-row">
      <!-- START: Watch column -->
      <div class="yt-wd-primary">
        <!-- START: Player running the ad -->
        <div class="yt-wd-player">
          <img
            *ngIf="thumbnailUrl; else noCreative"
            class="yt-wd-creative"
            [src]="thumbnailUrl"
            alt=""
          />

          <ng-template #noCreative>
            <div class="yt-wd-creative creative-missing">
              <ng-container *ngIf="isResolving; else askForVideo">
                Reading video formats&hellip;
              </ng-container>
              <ng-template #askForVideo>
                Add a {{ format }} video to see this preview
              </ng-template>
            </div>
          </ng-template>

          <!-- Player chrome. Fixed copy where it is the ad's frame, not the
               author's. Only drawn over a creative — it is white on the grey
               empty slot. -->
          <ng-container *ngIf="thumbnailUrl">
            <div class="yt-wd-overlay d-flex flex-row align-items-center">
              <img
                class="yt-wd-overlay-logo"
                src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
                alt=""
              />
              <div class="yt-wd-overlay-text">
                <div class="yt-wd-overlay-headline">{{ headline }}</div>
                <div class="yt-wd-overlay-url">{{ displayUrl }}</div>
              </div>
              <a
                class="yt-wd-overlay-cta"
                [href]="data.url"
                target="_blank"
                rel="noopener noreferrer"
                >{{ data.ctaText || "Your call to action" }}</a
              >
            </div>

            <span class="yt-wd-skip"
              >Skip Ad <i class="bi bi-skip-end-fill"></i
            ></span>
            <span class="yt-wd-countdown">00:08</span>
          </ng-container>
        </div>

        <!-- A yellow progress bar is what marks the player as running an ad. -->
        <div class="yt-wd-controls">
          <div class="yt-wd-progress"><span class="yt-wd-progress-fill"></span></div>
          <div class="yt-wd-buttons d-flex flex-row align-items-center">
            <i class="bi bi-pause-fill"></i>
          </div>
        </div>
        <!-- END: Player -->

        <!-- The watch page under the player, stubbed out: the ad is the subject. -->
        <span class="yt-wd-title placeholder"></span>
        <div class="yt-wd-channel d-flex flex-row">
          <span class="yt-wd-avatar placeholder"></span>
          <div class="yt-wd-channel-text d-flex flex-column">
            <span class="yt-wd-bar yt-wd-bar-lead placeholder"></span>
            <span class="yt-wd-bar yt-wd-bar-sub placeholder"></span>
          </div>
        </div>
      </div>
      <!-- END: Watch column -->

      <!-- START: Sidebar -->
      <div class="yt-wd-secondary">
        <!-- START: Companion banner — the same creative, cropped to a strip -->
        <a
          [href]="data.url"
          target="_blank"
          rel="noopener noreferrer"
          class="yt-wd-banner-link"
        >
          <img
            *ngIf="thumbnailUrl; else emptyBanner"
            class="yt-wd-banner"
            [src]="thumbnailUrl"
            alt=""
          />
          <ng-template #emptyBanner>
            <span class="yt-wd-banner"></span>
          </ng-template>
        </a>

        <div class="yt-wd-card d-flex flex-row align-items-center">
          <img
            class="yt-wd-card-logo"
            src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
            alt=""
          />
          <div class="yt-wd-card-text">
            <div class="yt-wd-card-headline">{{ headline }}</div>
            <div class="yt-wd-card-meta">
              <span class="yt-wd-card-sponsored">Sponsored</span> &middot;
              {{ displayUrl }}
            </div>
          </div>
          <a
            class="yt-wd-card-cta"
            [href]="data.url"
            target="_blank"
            rel="noopener noreferrer"
            >{{ data.ctaText || "Your call to action" }}</a
          >
        </div>
        <!-- END: Companion banner -->

        <!-- The up-next list, stubbed: identical rows, so one loop. -->
        <div class="yt-wd-up-next d-flex flex-column">
          <div
            class="yt-wd-up-row d-flex flex-row"
            *ngFor="let row of upNextRows"
          >
            <span class="yt-wd-up-thumb placeholder"></span>
            <div class="yt-wd-up-text d-flex flex-column">
              <span class="yt-wd-up-title placeholder"></span>
              <span class="yt-wd-up-line yt-wd-up-line-lead placeholder"></span>
              <span class="yt-wd-up-line yt-wd-up-line-sub placeholder"></span>
            </div>
          </div>
        </div>
      </div>
      <!-- END: Sidebar -->
    </div>
  </div>
  <!-- END: Watch page -->
</app-desktop-frame>
